import { FC } from 'react'
import * as Dropzone from 'react-dropzone'
import { styled } from '../../lib/stitches'
import { gray15, gray3, gray4, gray5 } from '../platform/color'
import { Column, Row } from './Components'
import { CloudUploadIcon } from './icons/icons'
import Text from './Text/Text'

// Styled Components

const DropzoneContainer = styled(Column, {
  width: '100%',
  border: `1px dashed ${gray5}`,
  borderRadius: '8px',
  background: gray3,
  justifyContent: 'center',
  alignItems: 'center',
  padding: '24px',
  marginBottom: '24px',
  transition: '100ms',
  '&:hover': {
    backgroundColor: gray4
  },
  variants: {
    disabled: {
      true: {
        '&:hover': {
          backgroundColor: gray3,
          cursor: 'not-allowed'
        }
      }
    }
  }
})

interface Props {
  getInputProps: <T extends Dropzone.DropzoneInputProps>(props?: T) => T
  getRootProps: <T extends Dropzone.DropzoneRootProps>(props?: T) => T
  title?: string
  description?: string
}

export const FilePicker: FC<Props> = ({
  getInputProps,
  getRootProps,
  title = 'Add or drop sounds here',
  description = 'Supports .wav format only'
}) => {
  const inputProps = getInputProps()
  const isDisabled = inputProps.onChange === null

  return (
    <DropzoneContainer {...getRootProps()} unselectable disabled={isDisabled}>
      <>
        <input {...inputProps} />
        <Row horizontalCenter verticalCenter>
          <Column css={{ marginRight: '16px' }}>
            <CloudUploadIcon height="32px" width="32px" style={{ color: gray15 }} />
          </Column>
          <Column>
            <Text size="14" fontWeight="medium">
              {title}
            </Text>
            <Text size="12" type="secondary">
              {description}
            </Text>
          </Column>
        </Row>
      </>
    </DropzoneContainer>
  )
}
